export const OSC = [
    { name: 'SubBeef', type: 'Kick' },
    { name: 'Lazy', type: 'Kick' },
    { name: 'Echoes', type: 'Kick' },
    { name: 'Lay', type: 'Kick' },
    { name: 'Hardstyle', type: 'Kick' },
    { name: 'Hardcore', type: 'Kick' },
    { name: 'Southpaw', type: 'Kick' },
    { name: '8BitGrime', type: 'Kick' },
    { name: 'Noiz', type: 'Kick' },
    { name: 'HiKnock', type: 'Kick' },
    { name: 'LoKnock', type: 'Kick' },
    { name: 'Tronica', type: 'Kick' },
    { name: 'HiClicky', type: 'Kick' },
    { name: 'LoClicky', type: 'Kick' },
    { name: 'Subsonic', type: 'Kick' },
    { name: 'Threed', type: 'Kick' },
    { name: 'Lololow', type: 'Kick' },
    { name: 'Risky', type: 'Kick' },
    { name: 'ShortBoom', type: 'Kick' },
    { name: 'AttackEight', type: 'Kick' },
    { name: 'PureEight', type: 'Kick' },
    { name: 'UltraEight', type: 'Kick' },
    { name: 'SnipEight', type: 'Kick' },
    { name: 'ShortNine', type: 'Kick' },
    { name: 'PureNine', type: 'Kick' },
    { name: 'BoostNine', type: 'Kick' },
    { name: 'Harder', type: 'Kick' },
    { name: 'BitBreak', type: 'Kick' },
    { name: 'Finger', type: 'Kick' },
    { name: 'Filthy', type: 'Kick' },
    { name: 'Visual', type: 'Kick' },
    { name: 'Breaker', type: 'Kick' },
    { name: 'Urban', type: 'Kick' },
    { name: 'Roomy', type: 'Kick' },
    { name: 'Studio', type: 'Kick' },
    { name: 'Twinkling', type: 'Kick' },
    { name: 'Hippy', type: 'Kick' },
    { name: 'Ringy', type: 'Kick' },
    { name: 'Womp', type: 'Kick' },
    { name: 'Hip', type: 'Kick' },
    { name: 'Jungle', type: 'Kick' },
    { name: 'EastCoast', type: 'Kick' },
    { name: 'Jazz', type: 'Kick' },
    { name: 'Rock', type: 'Kick' },
    { name: 'Warm', type: 'Kick' },
    { name: 'Breaks', type: 'Kick' },
    { name: "80'sR&B1", type: 'Kick' },
    { name: "80'sR&B2", type: 'Kick' },
    { name: "80'sR&B3", type: 'Kick' },
    { name: 'DDD1', type: 'Kick' },
    { name: 'DoncaMatic', type: 'Kick' },
    { name: 'BeatVox1', type: 'Kick' },
    { name: 'BeatVox2', type: 'Kick' },
    { name: 'BeatVox3', type: 'Kick' },
    { name: 'Reverse1', type: 'Kick' },
    { name: 'Reverse2', type: 'Kick' },
    { name: 'Aftertaste', type: 'Snare' },
    { name: 'Sharp', type: 'Snare' },
    { name: 'Toofer', type: 'Snare' },
    { name: 'Clpsnr', type: 'Snare' },
    { name: 'Bosh', type: 'Snare' },
    { name: 'Wide', type: 'Snare' },
    { name: 'BreaksLofi', type: 'Snare' },
    { name: 'Beach', type: 'Snare' },
    { name: 'Hefty', type: 'Snare' },
    { name: 'Goodie', type: 'Snare' },
    { name: 'Steady', type: 'Snare' },
    { name: 'Tech', type: 'Snare' },
    { name: 'Lay', type: 'Snare' },
    { name: 'LoNine', type: 'Snare' },
    { name: 'HiNine', type: 'Snare' },
    { name: 'CompNine', type: 'Snare' },
    { name: 'PureEight', type: 'Snare' },
    { name: 'BodyEight', type: 'Snare' },
    { name: 'TrapEight', type: 'Snare' },
    { name: 'Shortate', type: 'Snare' },
    { name: 'LeanSnare', type: 'Snare' },
    { name: 'Seventy', type: 'Snare' },
    { name: 'DDD1', type: 'Snare' },
    { name: 'Nuxx', type: 'Snare' },
    { name: 'Oldie', type: 'Snare' },
    { name: 'Bigger', type: 'Snare' },
    { name: "80'sR&B1", type: 'Snare' },
    { name: "80'sR&B2", type: 'Snare' },
    { name: 'Jazz1', type: 'Snare' },
    { name: 'Jazz2', type: 'Snare' },
    { name: 'Snappy', type: 'Snare' },
    { name: 'Ambee', type: 'Snare' },
    { name: 'Verdy', type: 'Snare' },
    { name: 'Tubeverb', type: 'Snare' },
    { name: 'Open1', type: 'Snare' },
    { name: 'Open2', type: 'Snare' },
    { name: 'Oldskool', type: 'Snare' },
    { name: 'Hoppy', type: 'Snare' },
    { name: 'Ringy', type: 'Snare' },
    { name: 'OldBreaks', type: 'Snare' },
    { name: 'Piccolo', type: 'Snare' },
    { name: 'Jungla', type: 'Snare' },
    { name: 'EastCoast', type: 'Snare' },
    { name: "D'n'B", type: 'Snare' },
    { name: 'Ambig', type: 'Snare' },
    { name: 'Juggler', type: 'Snare' },
    { name: 'DoncaMatic', type: 'Snare' },
    { name: 'Whip', type: 'Snare' },
    { name: 'Arcade', type: 'Snare' },
    { name: 'RimVox', type: 'Snare' },
    { name: 'Parched', type: 'Snare' },
    { name: 'Rimmy', type: 'Snare' },
    { name: 'AmbiRim', type: 'Snare' },
    { name: 'SnareVox', type: 'Snare' },
    { name: 'Waffle', type: 'Snare' },
    { name: 'Blast', type: 'Snare' },
    { name: 'Reverse1', type: 'Snare' },
    { name: 'Reverse2', type: 'Snare' },
    { name: 'PureEight', type: 'Clap' },
    { name: 'AmbEight', type: 'Clap' },
    { name: 'DirtySouth', type: 'Clap' },
    { name: 'PureNine', type: 'Clap' },
    { name: 'Mixed', type: 'Clap' },
    { name: 'Trap', type: 'Clap' },
    { name: 'Small', type: 'Clap' },
    { name: 'Clapper', type: 'Clap' },
    { name: 'Doubler', type: 'Clap' },
    { name: 'EastCoast', type: 'Clap' },
    { name: 'Liteclap', type: 'Clap' },
    { name: 'DDD1', type: 'Clap' },
    { name: 'Crispy', type: 'Clap' },
    { name: 'B.Boy', type: 'Clap' },
    { name: 'Crumbles', type: 'Clap' },
    { name: 'FingerSnap', type: 'Clap' },
    { name: 'NineClose1', type: 'HiHat' },
    { name: 'NineOpen1', type: 'HiHat' },
    { name: 'NineClose2', type: 'HiHat' },
    { name: 'NineOpen2', type: 'HiHat' },
    { name: 'EightClose1', type: 'HiHat' },
    { name: 'EightOpen1', type: 'HiHat' },
    { name: 'EightOpen2', type: 'HiHat' },
    { name: 'CompClose', type: 'HiHat' },
    { name: 'CompOpen', type: 'HiHat' },
    { name: 'EastClose', type: 'HiHat' },
    { name: 'EastOpen', type: 'HiHat' },
    { name: 'DDD1Close', type: 'HiHat' },
    { name: 'DDD1Open', type: 'HiHat' },
    { name: 'WarmClose', type: 'HiHat' },
    { name: 'WarmOpen', type: 'HiHat' },
    { name: 'ZeeClose', type: 'HiHat' },
    { name: 'ZeeOpen', type: 'HiHat' },
    { name: 'RoomyClose', type: 'HiHat' },
    { name: 'RoomyOpen', type: 'HiHat' },
    { name: 'RockClose', type: 'HiHat' },
    { name: 'RockOpen', type: 'HiHat' },
    { name: 'JazzClose', type: 'HiHat' },
    { name: 'JazzOpen', type: 'HiHat' },
    { name: 'HoppyClose', type: 'HiHat' },
    { name: 'HoppyOpen', type: 'HiHat' },
    { name: 'PhaseClose', type: 'HiHat' },
    { name: 'PhaseOpen', type: 'HiHat' },
    { name: 'NuHopClose', type: 'HiHat' },
    { name: 'NuHopOpen', type: 'HiHat' },
    { name: 'RightClose', type: 'HiHat' },
    { name: 'RightOpen', type: 'HiHat' },
    { name: 'NoizClose', type: 'HiHat' },
    { name: 'NoizOpen', type: 'HiHat' },
    { name: 'GranClose', type: 'HiHat' },
    { name: 'GranOpen', type: 'HiHat' },
    { name: 'Ambi', type: 'HiHat' },
    { name: 'Crackle', type: 'HiHat' },
    { name: 'Hippy', type: 'HiHat' },
    { name: 'Pump', type: 'HiHat' },
    { name: 'Voice1', type: 'HiHat' },
    { name: 'Voice2', type: 'HiHat' },
    { name: 'Reverse', type: 'HiHat' },
    { name: 'NineCym', type: 'Cymbal' },
    { name: 'Hi Cymbal', type: 'Cymbal' },
    { name: 'DoncaMatic', type: 'Cymbal' },
    { name: 'EastCoast', type: 'Cymbal' },
    { name: 'Rock', type: 'Cymbal' },
    { name: 'Synth', type: 'Cymbal' },
    { name: 'WhiteNoiz', type: 'Cymbal' },
    { name: 'RevCrash', type: 'Cymbal' },
    { name: 'NineRide', type: 'Cymbal' },
    { name: 'JazzRide1', type: 'Cymbal' },
    { name: 'JazzRide2', type: 'Cymbal' },
    { name: 'RockRide', type: 'Cymbal' },
    { name: 'ZeeRide', type: 'Cymbal' },
    { name: 'RevRide', type: 'Cymbal' },
    { name: 'Real Hi', type: 'Tom' },
    { name: 'Real MidHi', type: 'Tom' },
    { name: 'Real MidLo', type: 'Tom' },
    { name: 'Real Lo', type: 'Tom' },
    { name: 'Driven', type: 'Tom' },
    { name: 'Zee Hi', type: 'Tom' },
    { name: 'Zee Lo', type: 'Tom' },
    { name: 'OldSkool', type: 'Tom' },
    { name: 'Crunchy', type: 'Tom' },
    { name: 'E.Tom', type: 'Tom' },
    { name: 'Synth Hi1', type: 'Tom' },
    { name: 'Synth Mid1', type: 'Tom' },
    { name: 'Synth Lo1', type: 'Tom' },
    { name: 'Synth Hi2', type: 'Tom' },
    { name: 'Synth Lo2', type: 'Tom' },
    { name: 'TomEight', type: 'Tom' },
    { name: 'Conga1', type: 'Percussion' },
    { name: 'Conga2', type: 'Percussion' },
    { name: 'Conga3', type: 'Percussion' },
    { name: 'Conga4', type: 'Percussion' },
    { name: 'Conga5', type: 'Percussion' },
    { name: 'Bongo1', type: 'Percussion' },
    { name: 'Bongo2', type: 'Percussion' },
    { name: 'Bongo3', type: 'Percussion' },
    { name: 'Bongo4', type: 'Percussion' },
    { name: 'Bongo5', type: 'Percussion' },
    { name: 'Bongo6', type: 'Percussion' },
    { name: 'Djembe1', type: 'Percussion' },
    { name: 'Djembe2', type: 'Percussion' },
    { name: 'Djembe3', type: 'Percussion' },
    { name: 'Djembe4', type: 'Percussion' },
    { name: 'Darbuka1', type: 'Percussion' },
    { name: 'Darbuka2', type: 'Percussion' },
    { name: 'Darbuka3', type: 'Percussion' },
    { name: 'Darbuka4', type: 'Percussion' },
    { name: 'Timbales Hi', type: 'Percussion' },
    { name: 'Timbales Lo', type: 'Percussion' },
    { name: 'CowBell1', type: 'Percussion' },
    { name: 'CowBell2', type: 'Percussion' },
    { name: 'CowBell3', type: 'Percussion' },
    { name: 'Tambourine1', type: 'Percussion' },
    { name: 'Tambourine2', type: 'Percussion' },
    { name: 'Clave', type: 'Percussion' },
    { name: 'Guiro', type: 'Percussion' },
    { name: 'Cabasa', type: 'Percussion' },
    { name: 'Shaker', type: 'Percussion' },
    { name: 'WaveDrum1', type: 'Percussion' },
    { name: 'WaveDrum2', type: 'Percussion' },
    { name: 'WaveDrum3', type: 'Percussion' },
    { name: 'WaveDrum4', type: 'Percussion' },
    { name: 'WaveDrum5', type: 'Percussion' },
    { name: 'WaveDrum6', type: 'Percussion' },
    { name: 'WaveDrum7', type: 'Percussion' },
    { name: 'WaveDrum8', type: 'Percussion' },
    { name: 'ShakerHit', type: 'Percussion' },
    { name: 'RimPerc', type: 'Percussion' },
    { name: 'Wavestation', type: 'Percussion' },
    { name: 'RimNine', type: 'Percussion' },
    { name: 'RimEight', type: 'Percussion' },
    { name: 'SynthShake', type: 'Percussion' },
    { name: 'CowbellEight', type: 'Percussion' },
    { name: 'DoncaCongaS', type: 'Percussion' },
    { name: 'DoncaCongaL', type: 'Percussion' },
    { name: 'DoncaMaracas', type: 'Percussion' },
    { name: 'DoncaClaves', type: 'Percussion' },
    { name: 'DoncaW.block', type: 'Percussion' },
    { name: 'Synthclave', type: 'Percussion' },
    { name: 'ClickRoll', type: 'Percussion' },
    { name: 'GlitchDmg', type: 'Percussion' },
    { name: 'MouthPop', type: 'Percussion' },
    { name: 'Droplet', type: 'Percussion' },
    { name: 'Rave', type: 'Voice' },
    { name: 'Whoo', type: 'Voice' },
    { name: 'Ohooo', type: 'Voice' },
    { name: 'ComOn', type: 'Voice' },
    { name: 'Nahh', type: 'Voice' },
    { name: 'Ahaa..', type: 'Voice' },
    { name: 'Haa', type: 'Voice' },
    { name: 'Baaa', type: 'Voice' },
    { name: 'Grun', type: 'Voice' },
    { name: 'Ahaaw', type: 'Voice' },
    { name: 'Paa', type: 'Voice' },
    { name: 'Hey', type: 'Voice' },
    { name: 'Doh', type: 'Voice' },
    { name: 'GlitchEey', type: 'Voice' },
    { name: 'BotVox1', type: 'Voice' },
    { name: 'BotVox2', type: 'Voice' },
    { name: 'NoizyVox', type: 'Synth FX' },
    { name: 'Noiser', type: 'Synth FX' },
    { name: 'Botox', type: 'Synth FX' },
    { name: 'ShockSonar', type: 'Synth FX' },
    { name: 'Quark', type: 'Synth FX' },
    { name: 'ebPerc', type: 'Synth FX' },
    { name: 'Needle', type: 'Synth FX' },
    { name: 'SqueakyBum', type: 'Synth FX' },
    { name: 'SynSiren', type: 'Synth FX' },
    { name: 'Bubble', type: 'Synth FX' },
    { name: 'Burp', type: 'Synth FX' },
    { name: 'Lux', type: 'Synth FX' },
    { name: 'Squirt', type: 'Synth FX' },
    { name: 'Degraded', type: 'Synth FX' },
    { name: 'Flyby', type: 'Synth FX' },
    { name: 'SonicDrop', type: 'Synth FX' },
    { name: 'LoZap', type: 'Synth FX' },
    { name: 'SubBang', type: 'Synth FX' },
    { name: 'Stabium', type: 'Synth Hit' },
    { name: 'Futurize', type: 'Synth Hit' },
    { name: 'LilChord', type: 'Synth Hit' },
    { name: 'Ploinky', type: 'Synth Hit' },
    { name: 'Strippa', type: 'Synth Hit' },
    { name: 'BigChords', type: 'Synth Hit' },
    { name: 'StarBurst', type: 'Synth Hit' },
    { name: 'WishWash', type: 'Synth Hit' },
    { name: 'BangPop', type: 'Synth Hit' },
    { name: 'RegulatePop', type: 'Synth Hit' },
    { name: 'TigerPad', type: 'Synth Hit' },
    { name: 'LofiSynth', type: 'Synth Hit' },
    { name: 'BlastBass', type: 'Synth Hit' },
    { name: 'BenderBass', type: 'Synth Hit' },
    { name: 'RockHit1', type: 'Synth Hit' },
    { name: 'RockHit2', type: 'Synth Hit' },
    { name: 'FormantBass', type: 'Synth Hit' },
    { name: 'SynGrowl', type: 'Synth Hit' },
    { name: 'BrassHit1', type: 'Inst.Hit' },
    { name: 'BrassHit2', type: 'Inst.Hit' },
    { name: 'StringsHit1', type: 'Inst.Hit' },
    { name: 'StringsHit2', type: 'Inst.Hit' },
    { name: 'BadOrch', type: 'Inst.Hit' },
    { name: 'CarmOrch', type: 'Inst.Hit' },
    { name: 'Sho2DOrch', type: 'Inst.Hit' },
    { name: 'V2Orch', type: 'Inst.Hit' },
    { name: 'Suspended', type: 'Inst.Hit' },
    { name: 'Jazz', type: 'Inst.Hit' },
    { name: 'Jazzy', type: 'Inst.Hit' },
    { name: 'Hop', type: 'Inst.Hit' },
    { name: 'OldBrass', type: 'Inst.Hit' },
    { name: 'Record', type: 'Inst.Hit' },
    { name: 'Rave', type: 'Inst.Hit' },
    { name: 'Oldie', type: 'Inst.Hit' },
    { name: 'SAW', type: 'Synth' },
    { name: 'BOOST-SAW', type: 'Synth' },
    { name: 'PULSE', type: 'Synth' },
    { name: 'TRIANGLE', type: 'Synth' },
    { name: 'SINE', type: 'Synth' },
    { name: 'DUAL-SAW', type: 'Synth' },
    { name: 'DUAL-SQU', type: 'Synth' },
    { name: 'DUAL-TRI', type: 'Synth' },
    { name: 'DUAL-SINE', type: 'Synth' },
    { name: 'OCT-SAW', type: 'Synth' },
    { name: 'OCT-SQU', type: 'Synth' },
    { name: 'OCT-TRI', type: 'Synth' },
    { name: 'OCT-SINE', type: 'Synth' },
    { name: 'UNI-SAW', type: 'Synth' },
    { name: 'UNI-SQU', type: 'Synth' },
    { name: 'UNI-TRI', type: 'Synth' },
    { name: 'UNI-SINE', type: 'Synth' },
    { name: 'SYNC-SAW', type: 'Synth' },
    { name: 'SYNC-SQU', type: 'Synth' },
    { name: 'SYNC-TRI', type: 'Synth' },
    { name: 'SYNC-SINE', type: 'Synth' },
    { name: 'CHIP-TRI 1', type: 'Synth' },
    { name: 'CHIP-TRI 2', type: 'Synth' },
    { name: 'CHIP-PULSE', type: 'Synth' },
    { name: 'CHIP-NOISE', type: 'Synth' },
    { name: 'RING-SAW', type: 'Synth' },
    { name: 'RING-SQU', type: 'Synth' },
    { name: 'RING-TRI', type: 'Synth' },
    { name: 'RING-SINE', type: 'Synth' },
    { name: 'X-SAW 1', type: 'Synth' },
    { name: 'X-SAW 2', type: 'Synth' },
    { name: 'X-SQUARE 1', type: 'Synth' },
    { name: 'X-SQUARE 2', type: 'Synth' },
    { name: 'X-TRI 1', type: 'Synth' },
    { name: 'X-TRI 2', type: 'Synth' },
    { name: 'X-SINE 1', type: 'Synth' },
    { name: 'X-SINE 2', type: 'Synth' },
    { name: 'VPM-SAW', type: 'Synth' },
    { name: 'VPM-SQUARE', type: 'Synth' },
    { name: 'VPM-TRI', type: 'Synth' },
    { name: 'VPM-SINE 1', type: 'Synth' },
    { name: 'VPM-SINE 2', type: 'Synth' },
    { name: 'VPM-SINE 3', type: 'Synth' },
    { name: 'VPM-SINE 4', type: 'Synth' },
    { name: 'SYN-SINE 1', type: 'Synth' },
    { name: 'SYN-SINE 2', type: 'Synth' },
    { name: 'SYN-SINE 3', type: 'Synth' },
    { name: 'SYN-SINE 4', type: 'Synth' },
    { name: 'SYN-SINE 5', type: 'Synth' },
    { name: 'SYN-SINE 6', type: 'Synth' },
    { name: 'SYN-SINE 7', type: 'Synth' },
    { name: 'HPF NOISE', type: 'Synth' },
    { name: 'LPF NOISE', type: 'Synth' },
    { name: 'LOFI NOISE', type: 'Synth' },
    { name: 'RES NOISE', type: 'Synth' },
    { name: 'M1 Piano', type: 'Instrument' },
    { name: 'E.P.Roads', type: 'Instrument' },
    { name: 'E.P.Wurly', type: 'Instrument' },
    { name: 'Clav', type: 'Instrument' },
    { name: 'M1 Organ', type: 'Instrument' },
    { name: 'Brass Ens.', type: 'Instrument' },
    { name: 'Tenor Sax', type: 'Instrument' },
    { name: 'Alto Sax', type: 'Instrument' },
    { name: 'Strings Ens.', type: 'Instrument' },
    { name: 'Strings Pizz', type: 'Instrument' },
    { name: 'Vox Pop Ah', type: 'Instrument' },
    { name: 'Vox Pad', type: 'Instrument' },
    { name: 'Vox Helium', type: 'Instrument' },
    { name: 'A.Bass', type: 'Instrument' },
    { name: 'E.Bass Finger', type: 'Instrument' },
    { name: 'E.Bass Pick', type: 'Instrument' },
    { name: 'E.Bass Slap', type: 'Instrument' },
    { name: 'E.Bass Dist.', type: 'Instrument' },
    { name: 'A.Guitar', type: 'Instrument' },
    { name: 'E.Guitar1', type: 'Instrument' },
    { name: 'E.Guitar2', type: 'Instrument' },
    { name: 'Kalimba', type: 'Instrument' },
    { name: 'Metal Bell', type: 'Instrument' },
    { name: 'GamelanWave', type: 'Instrument' },
    { name: 'Bell1', type: 'Instrument' },
    { name: 'Bell2', type: 'Instrument' },
    { name: 'Bell3', type: 'Instrument' },
    { name: 'Bell4', type: 'Instrument' },
    { name: 'Audio In', type: 'Audio In' },
];
